// generated by genversion
module.exports = '2.5.0'



//////////////////
// WEBPACK FOOTER
// ./node_modules/tough-cookie/lib/version.js
// module id = RkQP
// module chunks = 1